const values = [
  {
    number: "01",
    title: "Atmosphere First",
    description: "Every experience begins not with a menu, but with a feeling. We ask: what should this space make you feel? Then we build everything around that answer."
  },
  {
    number: "02",
    title: "Nothing Generic",
    description: "We do not have packages or templates. Every table is conceived from a blank canvas — shaped entirely by your vision, your occasion, and your guests."
  },
  {
    number: "03",
    title: "Precision in Every Layer",
    description: "The weight of the crystal. The temperature of the room. The moment of the first pour. These details are not afterthoughts — they are the experience."
  },
  {
    number: "04",
    title: "Silence Over Spectacle",
    description: "True luxury is quiet. It does not announce itself. It simply surrounds you, and you know, without needing to be told, that you are somewhere exceptional."
  }
];

export default function PhilosophySection() {
  return (
    <section className="bg-[#0D0D0D] py-36 px-8 md:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Centered statement */}
        <div className="text-center max-w-3xl mx-auto mb-28">
          <div className="h-px w-16 bg-[#C9A961]/50 mx-auto mb-10" />
          <h2 className="font-serif text-[#FAF8F5] text-3xl md:text-4xl lg:text-5xl font-normal leading-[1.4] mb-8">
            <em className="italic text-[#E8DCC8]">Atmosphere.</em>{" "}
            <em className="italic text-[#E8DCC8]">Precision.</em>{" "}
            <em className="italic text-[#E8DCC8]">Discretion.</em>
          </h2>
          <p className="text-[#8A7F74] text-base font-light leading-relaxed">
            These are not just words. They are the three pillars around which every Table Privé experience is constructed. We hold them absolutely.
          </p>
        </div>

        {/* Values grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14">
          {values.map((v) => (
            <div key={v.number} className="flex gap-8 group">
              <div className="flex-shrink-0">
                <span className="font-serif text-[#C9A961]/30 text-3xl">{v.number}</span>
              </div>
              <div className="border-t border-[#2A2A2A] pt-6 flex-1">
                <h3 className="font-serif text-[#FAF8F5] text-xl mb-4">{v.title}</h3>
                <p className="text-[#8A7F74] text-sm font-light leading-relaxed">{v.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
